import type { TeamDetail, TeamMember } from 'modules/teams/types';

/** Students are the group's `member`s; co-teachers (`admin`) are managed under Settings, not graded. */
export const groupStudents = (team: Pick<TeamDetail, 'members'>): TeamMember[] =>
  team.members.filter((m) => m.role === 'member');

/** Downloads the group's students as `<group>-members.csv` (name, contact). */
export function downloadStudentsCsv(team: Pick<TeamDetail, 'name' | 'members'>, unknownName: string): void {
  const header = ['Name', 'Contact'];
  const body = groupStudents(team).map((m) =>
    [m.user?.name || unknownName, m.user?.email || ''].map((c) => `"${String(c).replace(/"/g, '""')}"`).join(','),
  );
  const csv = [header.join(','), ...body].join('\n');
  const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = `${team.name || 'group'}-members.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
